import React, { useEffect, useState } from "react";
import { Box, Chip, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCourierControlByMuestra } from "../../api/CourierControl/courierControlApi";

const fmtDate = (value) => {
  const raw = String(value || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return "";
  const [y, m, d] = raw.split("-");
  return `${d}/${m}/${y}`;
};

export default function CourierControlMuestraLinks({ muestra }) {
  const { t } = useTranslation();
  const id = muestra?.ID_MUESTRA || muestra?.id;
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!id) {
      setRows([]);
      return undefined;
    }
    let cancelled = false;
    getCourierControlByMuestra(id)
      .then((data) => {
        if (!cancelled) setRows(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setRows([]);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (!id) return null;

  return (
    <Box
      sx={{
        mt: 1.5,
        px: 1.25,
        py: 1.25,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: "0.92rem" }}>
        {t("courierControl.title")}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mt: 0.5 }}
      >
        {t("courierControl.shipmentOnSample")}
      </Typography>
      <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", mt: 1 }}>
        {rows.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            {t("courierControl.noShipments")}
          </Typography>
        ) : (
          rows.map((row) => (
            <Chip
              key={row.IdCourierControl}
              component={RouterLink}
              to={`/courier-control?id=${row.IdCourierControl}`}
              clickable
              size="small"
              label={[
                fmtDate(row.Fecha),
                row.Direccion === "ENTRADA"
                  ? t("courierControl.entry")
                  : t("courierControl.exit"),
                row.Destino || row.Origen || row.NumeroAwb || "",
              ]
                .filter(Boolean)
                .join(" · ")}
            />
          ))
        )}
      </Box>
    </Box>
  );
}
